<template>
    <div>
        <b-card-group class="row-cols-3">
            <b-col v-for="substance in substances">
                <Substance
                    :read-only="true"
                    :compact-view="true"
                    :substance="substance"
                    :substance-lists="substanceLists"
                />
            </b-col>
        </b-card-group>
    </div>
</template>
<script>
import {BCardGroup, BCol} from 'bootstrap-vue'
import Substance from "@/views/product/components/product-card/composition/SubstanceV4.vue";

export default {
    components: {
        BCardGroup, BCol, Substance
    },
    props: {
        substances: {
            type: Array,
            default() {
                return [];
            }
        },
        substanceLists: {
            type: Array,
            default() {
                return [];
            }
        }
    },
}
</script>
